#import "./todo-template-fragment.graphql"
#import "./closed-lead-email-automation-fragment.graphql"
#import "./closed-lead-slack-message-fragment.graphql"
#import "./account-type-automation-fragment.graphql"
#import "./nutshell-marketing-start-triggers-fragment.graphql"

fragment SalesAutomationClosedLeadAutomation on ClosedLeadAutomations {
    outcomeType
    followupLeadAutomations {
        id
        newStageset {
            id
            name
        }
        assigneeOrRule {
            ... on User {
                id
                name
            }
            ... on Team {
                id
                name
            }
            ... on LeadAssigneeRule {
                assignmentRule
            }
        }
        tags {
            id
            name
        }
    }
    taskTemplates {
        ...TodoTemplateCard
    }
    emailAutomations {
        ...ClosedLeadEmailAutomation
    }
    slackAutomations {
        ...ClosedLeadSlackMessage
    }
    accountTypeAutomations {
        ...AccountTypeAutomation
    }
    nutshellMarketingStartTriggers {
        ...NutshellMarketingStartTriggerFragment
    }
}
